import React from "react";
import Profile from "../Pngs/prof1.JPG";

export const About2 = () => {
  return (
    <div
      id="about"
      className="w-full min-h-screen bg-cyber-black text-gray-300 py-20 px-6 flex items-center justify-center relative border-t border-cyber-green/10"
    >
      <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
        
        {/* Left Section: Details & Bio */}
        <div className="space-y-6">
          <div>
            <h2 className="text-3xl font-mono font-bold text-cyber-green inline border-b-2 border-cyber-green pb-2">
              ABOUT_ME // INTEL
            </h2>
          </div>
          
          <div id="user-detail-intro" className="space-y-4">
            <p className="text-lg font-mono text-white leading-relaxed">
              &quot;A Full Stack Developer originally from Orai (UP), currently based in Ghaziabad. Driven by engineering high-performance backend architectures and pixel-perfect UI systems. Balancing enterprise-level development with academic pursuits in MCA.&quot;
            </p>
            
            <p className="text-sm text-cyber-gray-400 leading-relaxed">
              Equipped with a Rajput / Kshatriya Warrior mindset, I approach coding with precision, honor, and a relentless focus on excellence. I translate warrior discipline into optimizing backend performance, designing robust database schemas, and maintaining high server reliability.
            </p>
          </div>

          {/* Key Stats Terminal */}
          <div className="border border-cyber-blue/30 bg-cyber-darker p-5 rounded-xl font-mono text-xs space-y-3 shadow-glow-blue-sm">
            <div className="flex items-center space-x-2 border-b border-cyber-blue/20 pb-2 mb-2">
              <span className="w-2 h-2 rounded-full bg-cyber-blue" />
              <span className="text-cyber-blue uppercase font-bold">SYSTEM CONFIGURATION</span>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-cyber-gray-300">
              <div>
                <span className="text-cyber-green">ROLE:</span> Full Stack Developer
              </div>
              <div>
                <span className="text-cyber-green">GEOGRAPHY:</span> Ghaziabad / Noida, India
              </div>
              <div>
                <span className="text-cyber-green">ORIGIN:</span> Orai, Uttar Pradesh
              </div>
              <div>
                <span className="text-cyber-green">ACADEMICS:</span> MCA (Completed Sem 2)
              </div>
              <div>
                <span className="text-cyber-green">CURRENT_ORG:</span> GrowingPro Technologies
              </div>
              <div>
                <span className="text-cyber-green">TENURE:</span> Oct 2025 - Present (Full-Time)
              </div>
            </div>
          </div>
        </div>

        {/* Right Section: Experience Detail Cards */}
        <div className="space-y-6">
          <h3 className="text-xl font-mono font-bold text-cyber-blue flex items-center">
            <span>[PROFESSIONAL_RECORD]</span>
          </h3>

          <div className="space-y-4">
            {/* Professional Experience Card */}
            <div className="border border-cyber-gray-800 bg-cyber-dark/40 hover:border-cyber-blue/40 p-5 rounded-xl transition duration-300">
              <div className="flex justify-between items-start mb-2">
                <div>
                  <h4 className="font-bold text-white text-base">Full Stack Developer</h4>
                  <p className="text-xs font-mono text-cyber-green">GrowingPro Technologies</p>
                </div>
                <span className="text-xs font-mono text-cyber-gray-500">Oct 2025 - Present</span>
              </div>
              <p className="text-xs text-cyber-gray-400 mb-2 leading-relaxed">
                Currently based out of Sector 63, Noida. Focus on full-stack feature delivery, tuning complex database schemas, server-side process monitoring, and handling  pipeline transitions.
              </p>
              <div className="flex flex-wrap gap-1.5 pt-1">
                <span className="text-[10px] font-mono bg-cyber-black px-2 py-0.5 border border-cyber-gray-700 rounded text-cyber-blue">CRM System</span>
                <span className="text-[10px] font-mono bg-cyber-black px-2 py-0.5 border border-cyber-gray-700 rounded text-cyber-blue">Query Tuning</span>
                <span className="text-[10px] font-mono bg-cyber-black px-2 py-0.5 border border-cyber-gray-700 rounded text-cyber-blue">PM2 Monitor</span>
              </div>
            </div>

            {/* SDE Intern - Nolan Edutech */}
            <div className="border border-cyber-gray-800 bg-cyber-dark/40 hover:border-cyber-cyan/40 p-5 rounded-xl transition duration-300">
              <div className="flex justify-between items-start mb-2">
                <div>
                  <h4 className="font-bold text-white text-base">SDE Intern</h4>
                  <p className="text-xs font-mono text-cyber-cyan">Nolan Edutech Private Limited</p>
                </div>
                <span className="text-xs font-mono text-cyber-gray-500">Oct 2023 - Apr 2024</span>
              </div>
              <ul className="text-xs text-cyber-gray-400 space-y-1 leading-relaxed list-disc pl-4">
                <li>Worked on student dashboard modules using React and Node.js.</li>
                <li>Integrated REST APIs and enhanced UI responsiveness.</li>
                <li>Collaborated with backend and frontend teams in Agile sprints.</li>
              </ul>
              <div className="flex flex-wrap gap-1.5 pt-3">
                <span className="text-[10px] font-mono bg-cyber-black px-2 py-0.5 border border-cyber-gray-700 rounded text-cyber-cyan">React</span>
                <span className="text-[10px] font-mono bg-cyber-black px-2 py-0.5 border border-cyber-gray-700 rounded text-cyber-cyan">Node.js</span>
                <span className="text-[10px] font-mono bg-cyber-black px-2 py-0.5 border border-cyber-gray-700 rounded text-cyber-cyan">REST APIs</span>
              </div>
            </div>

            {/* Full Stack Developer Intern - Provoke Developers */}
            <div className="border border-cyber-gray-800 bg-cyber-dark/40 hover:border-cyber-purple/40 p-5 rounded-xl transition duration-300">
              <div className="flex justify-between items-start mb-2">
                <div>
                  <h4 className="font-bold text-white text-base">Full Stack Developer Intern</h4>
                  <p className="text-xs font-mono text-cyber-purple">Provoke Developers</p>
                </div>
                <span className="text-xs font-mono text-cyber-gray-500">May 2023 - Sep 2023</span>
              </div>
              <ul className="text-xs text-cyber-gray-400 space-y-1 leading-relaxed list-disc pl-4">
                <li>Built mini projects using MERN stack (CRUD apps, auth systems).</li>
                <li>Practiced Git workflow and project structuring in team setups.</li>
              </ul>
              <div className="flex flex-wrap gap-1.5 pt-3">
                <span className="text-[10px] font-mono bg-cyber-black px-2 py-0.5 border border-cyber-gray-700 rounded text-cyber-purple">MERN Stack</span>
                <span className="text-[10px] font-mono bg-cyber-black px-2 py-0.5 border border-cyber-gray-700 rounded text-cyber-purple">Tailwind CSS</span>
                <span className="text-[10px] font-mono bg-cyber-black px-2 py-0.5 border border-cyber-gray-700 rounded text-cyber-purple">Firebase</span>
              </div>
            </div>

            {/* Academic Pursuits Card */}
            <div className="border border-cyber-gray-800 bg-cyber-dark/40 hover:border-cyber-green/30 p-5 rounded-xl transition duration-300">
              <div className="flex justify-between items-start mb-2">
                <div>
                  <h4 className="font-bold text-white text-base">Master of Computer Applications</h4>
                  <p className="text-xs font-mono text-cyber-blue">MCA Degree Program</p>
                </div>
                <span className="text-xs font-mono text-cyber-gray-500">Sem-2 Submitted</span>
              </div>
              <p className="text-xs text-cyber-gray-400 leading-relaxed">
                Recently completed and submitted all 2nd-Semester assignments and projects successfully. Applying advanced concepts of computer systems, networks, and databases directly to enterprise development.
              </p>
            </div>

            {/* Masai Academic Card */}
            <div className="border border-cyber-gray-800 bg-cyber-dark/40 hover:border-cyber-cyan/30 p-5 rounded-xl transition duration-300">
              <div className="flex justify-between items-start mb-2">
                <div>
                  <h4 className="font-bold text-white text-base">Full Stack Web Development</h4>
                  <p className="text-xs font-mono text-cyber-cyan">Masai School</p>
                </div>
                <span className="text-xs font-mono text-cyber-gray-500">Apr 2022 – Jun 2023</span>
              </div>
              <p className="text-xs text-cyber-gray-400 leading-relaxed mb-2">
                Completed an intensive, industry-aligned Full Stack Web Development course. Focused on pixel-perfect frontend engineering, structured state management, and MERN stack systems design.
              </p>
              <div className="flex flex-wrap gap-1.5 pt-1">
                <span className="text-[10px] font-mono bg-cyber-black px-2 py-0.5 border border-cyber-gray-700 rounded text-cyber-cyan">HTML</span>
                <span className="text-[10px] font-mono bg-cyber-black px-2 py-0.5 border border-cyber-gray-700 rounded text-cyber-cyan">Chakra UI</span>
                <span className="text-[10px] font-mono bg-cyber-black px-2 py-0.5 border border-cyber-gray-700 rounded text-cyber-cyan">MERN Stack</span>
              </div>
            </div>
          </div>

        </div>

      </div>
    </div>
  );
};
